import "./header.scss";

/**
 * Header functional component that displays the World Vision logo.
 *
 * @returns {JSX.Element} The rendered header component.
 */
const Header = () => {
  return (
    <div className="logo-header">
      <img src={"https://wvusstatic.com/images/wv-logo-web.svg"} />
    </div>
  );
};

export default Header;
